import { Link } from 'react-router-dom'
import { Home, AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui'
import { ROUTES } from '@/constants'

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50">
      <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mb-6">
        <AlertTriangle size={40} className="text-yellow-600" />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">404</h1>
      <p className="text-lg text-gray-600 mb-2">Page Not Found</p>
      <p className="text-sm text-gray-500 mb-8 text-center max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to={ROUTES.DASHBOARD}>
        <Button leftIcon={<Home size={18} />}>
          Go Home
        </Button>
      </Link>
    </div>
  )
}

export default NotFoundPage
